import {z} from 'zod'

import {CreateOrUpdateBlockRichTextDocument} from '@sdox/api'

import {updateMetaSchema} from '../../utils/getUpdateMetaFromFieldValues'
import {createFormConfig} from '../../utils/createFormConfig'
import {i18nValidation} from '../../../../../i18n'

import type {BlockRichTextInput, CreateOrUpdateBlockRichTextMutation} from '@sdox/api'

export type UpdateRichTextValidatorSchema = z.infer<typeof updateRichTextValidatorSchema>

const updateRichTextValidatorSchema = z.object({
  data: z.object({
    text: z.string().min(1, {message: i18nValidation.enterText}),
  }),
  meta: updateMetaSchema,
})

export const richTextConfig = createFormConfig<
  UpdateRichTextValidatorSchema,
  CreateOrUpdateBlockRichTextMutation,
  BlockRichTextInput
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockRichTextDocument,
  },
  validatorSchema: updateRichTextValidatorSchema,
  fieldMapper: (fieldValues) => ({
    text: fieldValues.data.text,
  }),
  inputFields: [
    {
      label: 'Text',
      fieldName: 'data.text',
      inputType: 'richtext',
      defaultValue: '',
      required: false,
      placeholder: 'Write something using our powerful rich text editor',
    },
  ],
})
